import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  FORM_LOGIN,
  SET_CURRENT_PROFILE,
  LOGIN_USER_SUCCESS,
  USER_LOGOUT,
  SET_FORGOT_PASSWORD_CONFIRMATION_STATUS,
  FORGOT_PASSWORD_FORM,
  RESET_PASSWORD_FORM,
  FORM_REGISTER,
  LOGIN_ERROR,
  SET_IS_LOADING,
  CLEAR_LOGIN_ERROR,
  CLEAR_FORM_LOGIN,
  ENABLE_USER_ERROR,
  CLEAR_ENABLE_USER_ERROR,
  ENABLE_USER_PENDING_SUCCESS,
  SUCCESS_MESSAGE,
  CLEAR_SUCCESS_MESSAGE,
  SET_FORGOT_PASSWORD_PENDING,
  RESET_PASSWORD_PENDING,
  CLEAR_RESET_PASSWORD_PENDING,
  REDIRECT_TO_LOGIN,
  ENABLE_USER_PENDING,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  form: {},
  currentProfile: {
    userName: '',
    email: '',
    currentUserRoles: [],
    currentProfileRole: null,
    confirmationStatus: '',
    orgApplicationName: null,
    orgApplicationLogo: null,
  },
  isAuth: false,
  token: null,
  expires: null,
  email: null,
  isPending: false,
  errorMessage: null,
  confirmationStatus: '',
  formforgot: {},
  formRegister: {},
  isloading: true,
  enableUserError: null,
  enableUserSuccess: null,
  forgotPasswordSuccessMsg: null,
  forgotPasswordPending: false,
  resetPasswordPending: false,
  loginPage: false,
  enableUserPending: false
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    // case USER_LOGOUT:
    //   state = { ...state, isUserLogout: false };
    //   break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state, isUserLogout: true };
      break;
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        isUserLogout: false,
      };
      break;
    case FORM_LOGIN: {
      const { form } = action.payload;
      return {
        ...state,
        /* eslint-disable object-shorthand */
        form: form,
      }
    }
    case CLEAR_FORM_LOGIN: {
      return {
        ...state,
        /* eslint-disable object-shorthand */
        form: null,
      }
    }
    case FORGOT_PASSWORD_FORM: {
      const { formforgot } = action.payload;
      return {
        ...state,
        /* eslint-disable object-shorthand */
        formforgot: formforgot,
      }
    }
    case SUCCESS_MESSAGE: {
      const { result } = action.payload;
      return {
        ...state,
        /* eslint-disable object-shorthand */
        forgotPasswordSuccessMsg: result,
        forgotPasswordPending: false
      }
    }

    case SET_FORGOT_PASSWORD_PENDING: {
      return {
        ...state,
        /* eslint-disable object-shorthand */
        forgotPasswordPending: true,
      }
    }
    case RESET_PASSWORD_PENDING: {
      return {
        ...state,
        /* eslint-disable object-shorthand */
        resetPasswordPending: true,
      }
    }
    case CLEAR_RESET_PASSWORD_PENDING: {
      return {
        ...state,
        /* eslint-disable object-shorthand */
        resetPasswordPending: false,
      }
    }
    case REDIRECT_TO_LOGIN: {
      return {
        ...state,
        /* eslint-disable object-shorthand */
        loginPage: true,
      }
    }
    case CLEAR_SUCCESS_MESSAGE: {
      return {
        ...state,
        /* eslint-disable object-shorthand */
        forgotPasswordSuccessMsg: null,
      }
    }
    case RESET_PASSWORD_FORM: {
      const { formReset } = action.payload;
      return {
        ...state,
        /* eslint-disable object-shorthand */
        formReset: formReset,
      }
    }
    case FORM_REGISTER: {
      const { formRegister } = action.payload;
      return {
        ...state,
        /* eslint-disable object-shorthand */
        formRegister: formRegister,
      }
    }
    case SET_CURRENT_PROFILE: {
      const { currentProfile } = action.payload;
      return {
        ...state,
        /* eslint-disable object-shorthand */
        currentProfile: currentProfile,
      };
    }
    case SET_FORGOT_PASSWORD_CONFIRMATION_STATUS: {
      const { confirmationStatus } = action.payload;
      return {
        ...state,
        confirmationStatus: confirmationStatus
      }
    }

    case LOGIN_USER_SUCCESS: {
      const { email, token, expires } = action.payload;
      return {
        ...state,
        email,
        token,
        expires,
        isAuth: true,
        errorMessage: null,
        isPending: false,
      };
    }

    case LOGIN_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...state,
        errorMessage: errorMessage

      };
    }
    case CLEAR_LOGIN_ERROR: {
      return {
        ...state,
        errorMessage: null

      };
    }
    case SET_IS_LOADING: {
      const { isloading } = action.payload;
      return {
        ...state,
        isloading: isloading

      };
    }
    case ENABLE_USER_PENDING: {
      return {
        ...state,
        enableUserPending: true

      };
    }

    case ENABLE_USER_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...state,
        enableUserError: errorMessage,
        enableUserSuccess: null,
        enableUserPending: false
      };
    }

    case CLEAR_ENABLE_USER_ERROR: {
      return {
        ...state,
        enableUserError: null,
        enableUserSuccess: null,
      };
    }

    case ENABLE_USER_PENDING_SUCCESS: {
      const { result } = action.payload;
      return {
        ...state,
        enableUserError: result,
        enableUserSuccess: result,
        enableUserPending: false,
      };
    }

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
